
import { defineComponent, onMounted ,ref , watch, } from "vue";
import { useRouter,  useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { MenuComponent } from "@/assets/ts/components";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import { headerMenuIcons } from "@/core/helpers/config";
import AuthService from "@/services/AuthService";
import store from "@/store/index";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import useUserPendingDataModal from "@/layout/UserPendingDataModal/composables/UserPendingDataModal";

export default defineComponent({
  name: "KTMenu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const router = useRouter();
    
    let dominio_gestao = store.getters.layoutConfig("distribuidor.dominio_gestao");
    let tipo_conexao = store.getters.layoutConfig("distribuidor.tipo_conexao");
    let distribuidor = store.getters.layoutConfig("distribuidor.distribuidor");
    let link_v2 = "";
    let link_v3 = "../v3"

    const hidenMenuHeaders = ['stellantis']

    if(dominio_gestao == "localhost:8080"){
      link_v2 = tipo_conexao+"://localhost/acampa-gestao-pra/v2";
    }else{
      link_v2 = "../v2";
    }

    const userInfo = AuthService.getUsuarioAuth();
    const codNivel = userInfo.codNivel;

    const menuHeaders = [
      {
        sectionTitle: "Dashboards",
        route: "/subscriptions1",
        codRequired: [-1, 1, 2],
        hiddenDistribuidor : ['stellantis'],
        sub: [
          {
            heading: "One Page Report",
            route: "dashboard",
            svgIcon: "./media/icons/duotune/files/fil024.svg"
          },
          {
            heading: "Por Grupo",
            route: link_v3 + "/one-page-report-grupo",
            svgIcon: "./media/icons/duotune/graphs/gra010.svg"
          },
          {
            heading: "Por marca",
            route: link_v3 + "/one-page-report-marca",
            svgIcon: "./media/icons/duotune/technology/teh004.svg"
          },
          // {
          //   heading: "Business Inteligence",
          //   route: link_v2 + "/dashboard.php",
          //   svgIcon: "./media/icons/duotune/technology/teh003.svg"
          // },
          {
            heading: "Business Inteligence",
            route: link_v3 + "/business-inteligence",
            svgIcon: "./media/icons/duotune/technology/teh003.svg"
          },
        ],
      },
    ]

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };
     const notificationRef = ref(store.getters.notificationsSession);

    onMounted(() => {
      MenuComponent.reinitialization();
    });



      store.watch(() => store.getters.notificationsSession, async () => {
              notificationRef.value = store.getters.notificationsSession;			
			}, {deep:true});

      function goTo(){
         router.push("/oficina-digital/gerenciar");
      }

      function limpar(){
     store.commit(Mutations.DELETE_ALL_NOTIFICATION);
     store.dispatch(Actions.ALTER_TITLE);
      }

      useUserPendingDataModal().handlePendingDataNotificationToNotificationRef(notificationRef)
    return {
      hasActiveChildren,
      headerMenuIcons,
      MainMenuConfig,
      menuHeaders,
      translate,
      codNivel,
      link_v2,
      notificationRef,
      link_v3,
      goTo,
      limpar,
      distribuidor,
      hidenMenuHeaders
    };
  },
});
